const SPECIAL_TITLES = [
    "Blood taken by a professional in-clinic",
    "Book a home nurse visit to have your blood sample taken",
    "In clinic appointment",
];
const SPECIAL_TITLES_CLINIC = [
    "Blood taken by a professional in-clinic",
    "In clinic appointment",
];
const SPECIAL_TITLES_MOBILE = [
    "Book a home nurse visit to have your blood sample taken",
];
const TITLES_HOME_TESTS = [
    "Blood taken at home via finger-prick kit",
    "Organise my own blood collection",
    "Collect Sample at Home",
    "1 Body Part",
    "2 Body Parts",
    "Book Prostate MRI Scan",
    "Full Body MRI Scan – Gold",
    "Full Body MRI Scan – Gold with prostate screening",
    "Full Body MRI Scan – Platinum",
    "Full Body MRI Scan – Platinum with prostate screening",
];
const SPECIAL_TITLES_HOME = [
    "Blood taken at home via finger-prick kit",
    "Organise my own blood collection",
    "Collect Sample at Home",
];

function logDiscountDebug(eventName, payload) {
    // TEMP DEBUG: verify flow and variant IDs before booking/cart steps.
    try {
        console.log('[GBC Discount Debug] ' + eventName, payload);
    } catch (e) {
    }
    try {
        var storageKey = 'gbc_discount_debug_logs';
        var raw = sessionStorage.getItem(storageKey);
        var logs = [];
        if (raw) {
            try {
                logs = JSON.parse(raw) || [];
            } catch (e) {
                logs = [];
            }
        }
        logs.push({
            ts: new Date().toISOString(),
            source: 'bloodtest-variant-change.js',
            event: eventName,
            payload: payload || {},
        });
        if (logs.length > 200) {
            logs = logs.slice(logs.length - 200);
        }
        sessionStorage.setItem(storageKey, JSON.stringify(logs));
    } catch (e) {
    }
}

// --- Flow detection (home vs clinic vs mobile) ---
function normalizeVariantTitle(title) {
    return String(title || "")
        .toLowerCase()
        .replace(/[\u2010-\u2015]/g, "-")
        .replace(/\s+/g, " ")
        .trim();
}

function isFingerPrickVariantTitle(title) {
    const normalized = normalizeVariantTitle(title);
    if (!normalized) return false;

    const known = SPECIAL_TITLES_HOME.some(function (t) {
        return normalizeVariantTitle(t) === normalized;
    });
    if (known) return true;

    // Fallback for small content edits (e.g., hyphen changes in "finger-prick")
    return normalized.includes("finger") && normalized.includes("prick");
}

function getCurrentCollectionMethodValue() {
    return $(
        'input[type="radio"][name*="Collection Method-1"]:checked, ' +
        'input[type="radio"][name*="Options-1"]:checked, ' +
        'input[type="radio"][name*="Recording-1"]:checked',
    ).val() || "";
}

function isHomeTestCollectionMethod(value) {
    const normalized = normalizeVariantTitle(value);
    if (!normalized) return false;

    const exactKnown = TITLES_HOME_TESTS.some(function (t) {
        return normalizeVariantTitle(t) === normalized;
    });
    if (exactKnown) return true;

    // Fallback for minor content wording changes
    return normalized.includes("home") || (normalized.includes("finger") && normalized.includes("prick"));
}

// --- Flow routing (isHomeTestFlow) ---
function getCurrentCollectionFlow() {
    const selectedCollectionMethod = $(
        'input[type="radio"][name*="Collection Method-1"]:checked, ' +
        'input[type="radio"][name*="Options-1"]:checked, ' +
        'input[type="radio"][name*="Recording-1"]:checked',
    ).val();
    const variantId = getSelectedVariantId();
    const selectedVariantData = variantId ? getMainProductVariantData(variantId) : null;
    const hasCollectionMethodChoices = document.querySelectorAll(
        'input[type="radio"][name*="Collection Method-1"], ' +
        'input[type="radio"][name*="Options-1"], ' +
        'input[type="radio"][name*="Recording-1"]',
    ).length > 0;

    let collectionMethod = selectedCollectionMethod || '';
    if (!collectionMethod) {
        const selectedVariantsScript = document.querySelector('[data-selected-variant]');
        if (selectedVariantsScript) {
            try {
                const selectedVariant = JSON.parse(selectedVariantsScript.textContent || '{}');
                collectionMethod = selectedVariant.option1 || '';
            } catch (err) {
                // Ignore parse errors and use additional fallbacks below
            }
        }
    }
    if (!collectionMethod && selectedVariantData && selectedVariantData.title) {
        collectionMethod = selectedVariantData.title;
    }

    const isClinicFlow = SPECIAL_TITLES_CLINIC.includes(collectionMethod);
    const isMobileFlow = SPECIAL_TITLES_MOBILE.includes(collectionMethod);
    const inferredHomeFlow = !hasCollectionMethodChoices && !isClinicFlow && !isMobileFlow;
    let isHomeTestFlow = isHomeTestCollectionMethod(collectionMethod) || isFingerPrickVariantTitle(collectionMethod) || inferredHomeFlow;

    // "NAD+" and "Consultation" products should never go through the home-test → patient-details flow.
    const productTitle = (document.getElementById('product-title') && document.getElementById('product-title').value)
        || (document.querySelector('.product__title, .product-title, h1') && document.querySelector('.product__title, .product-title, h1').textContent.trim())
        || '';

    const isExcludedProduct = /nad\s*\+/i.test(productTitle) || /consultation/i.test(productTitle);
    if (isExcludedProduct) {
        isHomeTestFlow = false;
    }

    return {
        variantId: variantId,
        collectionMethod: collectionMethod,
        isClinicFlow: isClinicFlow,
        isMobileFlow: isMobileFlow,
        isHomeTestFlow: isHomeTestFlow,
    };
}

// Discount for home test upsells (sample taken at home and sent to be processed)
// This is a placeholder that can be easily changed in the future
const HOME_TEST_UPSELL_DISCOUNT = 0;
window.__subscriptionStepActive = false;

const VARIANT_CHANGE_DELAY = 400;

// Helper function to parse price strings that may contain commas (e.g., "1,499.00")
function parsePrice(priceString) {
    if (window.GbcSubscriptionShared && typeof window.GbcSubscriptionShared.parsePrice === 'function') {
        return window.GbcSubscriptionShared.parsePrice(priceString);
    }
    if (typeof priceString === 'number') {
        return priceString;
    }
    if (typeof priceString !== 'string') {
        return 0;
    }
    // Remove commas and parse as float
    return parseFloat(priceString.replace(/,/g, '')) || 0;
}

function parseMoneyText(text) {
    if (!text) return 0;
    const cleaned = String(text).replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    return parseFloat(cleaned) || 0;
}

// --- Variant & plan data (priority: main-product-variants → payload → picker DOM → purchase-options DOM → product JSON) ---
function getSelectedVariantId() {
    // First, try to get from data-selected-variant script (most reliable for all product types)
    const selectedVariantsScript = document.querySelector('[data-selected-variant]');
    if (selectedVariantsScript) {
        try {
            const selectedVariants = JSON.parse(selectedVariantsScript.textContent);
            if (selectedVariants && selectedVariants.id) {
                return Number(selectedVariants.id);
            }
        } catch (e) {
            console.error('Error parsing selected variant:', e);
        }
    }

    // If not found, try to get variant from radio buttons (for blood tests with Collection Method, Options, or Recording)
    const selectedRadio = $(
        'input[type="radio"][name*="Collection Method-1"]:checked, ' +
        'input[type="radio"][name*="Options-1"]:checked, ' +
        'input[type="radio"][name*="Recording-1"]:checked',
    );

    if (selectedRadio.length) {
        const variantId = selectedRadio.closest('label').find('.var_price').data('nid');
        if (variantId) {
            return Number(variantId);
        }
    }

    // If still not found, try to get from any checked radio button with var_price
    const anyCheckedRadio = $('input[type="radio"]:checked');
    if (anyCheckedRadio.length) {
        const variantId = anyCheckedRadio.closest('label').find('.var_price').data('nid');
        if (variantId) {
            return Number(variantId);
        }
    }

    // If still not found, try to get from the form's hidden variant input (standard Shopify method)
    const variantInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    if (variantInput && variantInput.value) {
        const variantId = Number(variantInput.value);
        if (!isNaN(variantId)) {
            return variantId;
        }
    }

    return null;
}

function getMainProductVariantData(variantId) {
    const scriptEl = document.getElementById('main-product-variants');
    if (!scriptEl || !scriptEl.textContent) {
        return null;
    }
    try {
        const variants = JSON.parse(scriptEl.textContent.trim());
        if (Array.isArray(variants)) {
            const matched = variants.find(function (v) {
                return Number(v.id) === Number(variantId);
            }) || null;
            return matched;
        }
    } catch (e) {
        console.error('getMainProductVariantData', e);
    }
    return null;
}

function getSelectedVariantPayload() {
    const selectedVariantsScript = document.querySelector('[data-selected-variant]');
    if (!selectedVariantsScript || !selectedVariantsScript.textContent) return null;
    try {
        const payload = JSON.parse(selectedVariantsScript.textContent);
        return payload;
    } catch (e) {
        return null;
    }
}

function getSellingPlansFromVariantPayload(payload) {
    if (!payload || !Array.isArray(payload.selling_plan_allocations)) return [];
    const plans = [];
    payload.selling_plan_allocations.forEach(function (alloc) {
        if (!alloc) return;
        const planId = alloc.selling_plan_id
            || (alloc.selling_plan && alloc.selling_plan.id)
            || (alloc.plan && alloc.plan.id)
            || null;
        if (!planId) return;
        const planName = (alloc.selling_plan && alloc.selling_plan.name)
            || (alloc.plan && alloc.plan.name)
            || alloc.name
            || 'Subscription';
        const planPriceRaw = alloc.price !== undefined ? alloc.price
            : (alloc.per_delivery_price !== undefined ? alloc.per_delivery_price : null);
        let planPrice = 0;
        if (typeof planPriceRaw === 'number') {
            // Shopify payloads often expose money in cents
            planPrice = planPriceRaw > 1000 ? (planPriceRaw / 100) : planPriceRaw;
        } else {
            planPrice = parsePrice(planPriceRaw || 0);
        }
        plans.push({
            id: Number(planId),
            name: String(planName),
            price: planPrice,
        });
    });
    return plans;
}

function getMainVariantDataFromSelectedPickerDom(variantId) {
    const selectedPickerInput = document.querySelector('input[name="subscription_picker"]:checked');
    if (!selectedPickerInput) {
        return null;
    }

    const variantLabel = selectedPickerInput.closest('label.full_width_variant') || selectedPickerInput.closest('label');
    if (!variantLabel) return null;

    const titleNode = variantLabel.querySelector('.var_title_text');
    const varPriceNode = variantLabel.querySelector('.var_price');
    const discountedNode = variantLabel.querySelector('.discounted_price');
    const title = titleNode ? titleNode.textContent.trim() : (selectedPickerInput.value || '');
    const basePrice = parseMoneyText(varPriceNode ? varPriceNode.textContent : '');

    const planInputs = variantLabel.querySelectorAll('input[name="selling_plan"]');
    const plans = [];
    planInputs.forEach(function (input, idx) {
        const planId = (input.value || '').trim();
        if (!planId) return; // skip one-time
        const parentLabel = input.closest('label') || variantLabel.querySelector('label[for="' + input.id + '"]');
        const labelText = parentLabel ? parentLabel.textContent : '';
        const smallNode = parentLabel ? parentLabel.querySelector('small') : null;
        const planPrice = parseMoneyText(smallNode ? smallNode.textContent : labelText);
        const planName = (function () {
            if (!labelText) return 'Subscription';
            const compact = labelText.replace(/\s+/g, ' ').trim();
            const m = compact.match(/(\d+\s*month[s]?[^£()]*)/i);
            if (m && m[1]) return m[1].trim();
            return 'Subscription ' + (idx + 1);
        })();
        plans.push({
            id: Number(planId),
            name: planName,
            price: (planPrice || parseMoneyText(discountedNode ? discountedNode.textContent : '')) || basePrice,
        });
    });

    const data = {
        id: Number(variantId || (varPriceNode && varPriceNode.dataset && varPriceNode.dataset.id) || 0),
        title: title || '',
        price: basePrice || parseMoneyText(discountedNode ? discountedNode.textContent : ''),
        selling_plan_id: plans.length ? plans[0].id : '',
        selling_plans: plans,
    };
    return data;
}

function getMainVariantDataFromPurchaseOptionsDom(variantId) {
    const allSellingPlanInputs = Array.from(document.querySelectorAll('input[name="selling_plan"]'));
    if (!allSellingPlanInputs.length) {
        return null;
    }

    const title = (document.getElementById('product-title') && document.getElementById('product-title').value)
        || (document.querySelector('.product__title, .product-title, h1') && document.querySelector('.product__title, .product-title, h1').textContent.trim())
        || '';

    function labelForInput(input) {
        if (!input) return null;
        return input.closest('label') || document.querySelector('label[for="' + input.id + '"]');
    }

    const oneTimeInput = allSellingPlanInputs.find(function (input) {
        return !String(input.value || '').trim();
    });
    const oneTimeLabel = labelForInput(oneTimeInput);
    const oneTimeSmall = oneTimeLabel ? oneTimeLabel.querySelector('small') : null;
    const oneTimePrice = parseMoneyText(oneTimeSmall ? oneTimeSmall.textContent : '');

    let basePrice = oneTimePrice;
    if (!basePrice) {
        const varPriceNode = document.querySelector('.var_price');
        if (varPriceNode) basePrice = parseMoneyText(varPriceNode.textContent);
    }
    if (!basePrice) {
        const regularPriceNode = document.querySelector('.price .price-item--regular, .price-item--regular, .price-item');
        if (regularPriceNode) basePrice = parseMoneyText(regularPriceNode.textContent);
    }

    const plans = [];
    allSellingPlanInputs.forEach(function (input, idx) {
        const planId = String(input.value || '').trim();
        if (!planId) return;
        const lbl = labelForInput(input);
        const labelText = lbl ? lbl.textContent.replace(/\s+/g, ' ').trim() : '';
        const small = lbl ? lbl.querySelector('small') : null;
        const planPrice = parseMoneyText(small ? small.textContent : labelText);
        const normalizedName = (function () {
            if (!labelText) return 'Subscription ' + (idx + 1);
            const m = labelText.match(/(\d+\s*month[s]?[^£()]*)/i);
            if (m && m[1]) return m[1].trim();
            return labelText.length > 60 ? labelText.slice(0, 60) : labelText;
        })();
        plans.push({
            id: Number(planId),
            name: normalizedName,
            price: planPrice || basePrice,
        });
    });

    const checkedPlanInput = allSellingPlanInputs.find(function (input) {
        return input.checked && String(input.value || '').trim();
    });
    const data = {
        id: Number(variantId || 0),
        title: title,
        price: basePrice,
        selling_plan_id: checkedPlanInput ? Number(checkedPlanInput.value) : (plans.length ? plans[0].id : ''),
        selling_plans: plans,
    };
    return data;
}

async function getMainVariantDataFromProductJson(variantId) {
    function getProductHandleFromPage() {
        const handleInput = document.getElementById('real-product-handle');
        if (handleInput && handleInput.value) return handleInput.value;

        const canonical = document.querySelector('link[rel="canonical"]')?.href || '';
        const canonicalMatch = canonical.match(/\/products\/([^/?#]+)/i);
        if (canonicalMatch && canonicalMatch[1]) return canonicalMatch[1];

        const pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/i);
        if (pathMatch && pathMatch[1]) return pathMatch[1];

        return '';
    }

    const handle = getProductHandleFromPage();
    if (!handle) {
        return null;
    }
    try {
        const res = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
            credentials: 'same-origin',
        });
        if (!res.ok) {
            return null;
        }
        const product = await res.json();
        const variant = (product.variants || []).find(function (v) {
            return Number(v.id) === Number(variantId);
        });
        const basePrice = variant && variant.price ? Number(variant.price) / 100 : 0;
        const plans = [];
        (product.selling_plan_groups || []).forEach(function (group) {
            (group.selling_plans || []).forEach(function (plan) {
                if (!plan || !plan.id) return;
                let computedPrice = basePrice;
                const adj = Array.isArray(plan.price_adjustments) && plan.price_adjustments.length ? plan.price_adjustments[0] : null;
                if (adj) {
                    if (adj.value_type === 'percentage' && typeof adj.value === 'number') {
                        computedPrice = basePrice * (1 - (adj.value / 100));
                    } else if (adj.value_type === 'fixed_amount' && typeof adj.value === 'number') {
                        computedPrice = basePrice - (adj.value / 100);
                    } else if (adj.value_type === 'price' && typeof adj.value === 'number') {
                        computedPrice = adj.value / 100;
                    }
                }
                plans.push({
                    id: Number(plan.id),
                    name: String(plan.name || (group.name || 'Subscription')),
                    price: computedPrice > 0 ? computedPrice : basePrice,
                });
            });
        });

        const out = {
            id: Number(variantId || 0),
            title: (variant && (variant.option1 || variant.title)) || (product.title || ''),
            price: basePrice,
            selling_plan_id: plans.length ? plans[0].id : '',
            selling_plans: plans,
        };
        window.__productJsonVariantDataCache = window.__productJsonVariantDataCache || {};
        window.__productJsonVariantDataCache[out.id] = out;
        return out;
    } catch (e) {
        return null;
    }
}

// --- Cart / session / upsell helpers ---
function saveProductDataToSession(data) {
    const variantId = data.variant_id || getSelectedVariantId();
    if (variantId) {
        const variantData = getMainProductVariantData(variantId);
        if (variantData) {
            data.main_variant_title = variantData.title || '';
            data.main_variant_selling_plan_id = variantData.selling_plan_id || '';
            data.main_variant_selling_plans = JSON.stringify(variantData.selling_plans || []);
            data.main_variant_price = variantData.price || '';
        }
    }
    Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
            sessionStorage.setItem(key, String(data[key]));
        }
    });
}

// Helper function to create cart item properties from patient data
function createCartItemProperties(patientData, productHandle, eurofinsCode) {
    if (patientData.email != '') {
        var properties = {
            'First Name': patientData.firstName || '',
            'Last Name': patientData.lastName || '',
            'Date of Birth': patientData.dob ? patientData.dob.split('-').reverse().join('/') : '',
            'Gender': patientData.gender || '',
            //'Email': patientData.email || '',
            'Preferred Date 1': patientData.pdate1 ? patientData.pdate1.split('-').reverse().join('/') + " " + patientData.ptime1 : '',
            'Preferred Date 2': patientData.pdate2 ? patientData.pdate2.split('-').reverse().join('/') + " " + patientData.ptime2 : '',
            'Preferred Date 3': patientData.pdate3 ? patientData.pdate3.split('-').reverse().join('/') + " " + patientData.ptime3 : '',
            'Pace-Maker Fitted': patientData.pmaker || '',
        };
    } else {
        var properties = {
            'First Name': patientData.firstName || '',
            'Last Name': patientData.lastName || '',
            'Date of Birth': patientData.dob ? patientData.dob.split('-').reverse().join('/') : '',
            'Gender': patientData.gender || '',
        };
    }


    if (productHandle && productHandle !== 'undefined') {
        properties.product_id = productHandle;
    }

    if (eurofinsCode && eurofinsCode !== 'undefined') {
        properties.product_code = eurofinsCode;
    }

    return properties;
}

// Helper function to get metafields element (cached)
function getMetafieldsElement() {
    return document.getElementById('product-metafields');
}

// Helper function to get and parse upsells from metafields
function getUpsellsFromMetafields() {
    const metafieldsEl = getMetafieldsElement();
    if (!metafieldsEl || !metafieldsEl.dataset.upsells) {
        return null;
    }
    try {
        const parsed = JSON.parse(metafieldsEl.dataset.upsells);
        return parsed;
    } catch (e) {
        console.error('Error parsing upsells:', e);
        return null;
    }
}

//JS for changing the display depending on variant type (show postcode search for mobile and show book now or add to cart) 
$(document).on('change', 'input[type="radio"][name*="Collection Method-1"]', function () {
    const collMethod = $(this).val();
    const submitButtonSpan = document.querySelector('product-form [type="submit"] span');

    setTimeout(() => {
        if (submitButtonSpan) {
            if (SPECIAL_TITLES.includes(collMethod)) {
                submitButtonSpan.textContent = "Book now";
                jQuery(".shopify-payment-button").hide();
            } else {
                submitButtonSpan.textContent = window.variantStrings?.addToCart || "Add to cart";
                if (TITLES_HOME_TESTS.includes(collMethod)) {
                    jQuery(".shopify-payment-button").hide();
                } else {
                    jQuery(".shopify-payment-button").show();
                }
            }
        }
        if (SPECIAL_TITLES_MOBILE.includes(collMethod)) {
            jQuery("#mobileBookingPostcodeCheck").removeClass('disp_none');
        } else {
            jQuery("#mobileBookingPostcodeCheck").addClass('disp_none');
        }
    }, VARIANT_CHANGE_DELAY);
});


// Helper function to save upsells to sessionStorage
function saveUpsellsToSession() {
    const metafieldsEl = getMetafieldsElement();
    if (metafieldsEl && metafieldsEl.dataset.upsells) {
        sessionStorage.setItem('upsells', metafieldsEl.dataset.upsells);
    }
}

// Helper function to get variant SKU from selected radio button
function getVariantSku() {
    const selectedRadio = $('input[type="radio"][name*="Collection Method-1"]:checked');
    if (selectedRadio.length) {
        return selectedRadio.closest('label').find('.var_price').data('sku');
    }
    return null;
}

// --- Patient modal (ensure + open) ---
// QA_SUBSCRIPTIONS_START
// Fallback for QA: some product templates do not render #thankYouModal/#modalBackdrop.
function ensurePatientModalElements() {
    let modal = document.getElementById('thankYouModal');
    let backdrop = document.getElementById('modalBackdrop');

    if (!modal) {
        modal = document.createElement('div');
        modal.id = 'thankYouModal';
        modal.className = 'thank-you-modal';
        modal.style.cssText = 'display:none; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background: white; padding: 40px; box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 8px; z-index: 1000; border-radius: 8px; width: 90%; max-width: 800px;';
        modal.innerHTML = '<div class="thank-you-modal__content" style="position: relative;"></div>';
        document.body.appendChild(modal);
    }

    if (!backdrop) {
        backdrop = document.createElement('div');
        backdrop.id = 'modalBackdrop';
        backdrop.style.cssText = 'display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: #707070; opacity: 0.8; z-index: 999;';
        document.body.appendChild(backdrop);
        backdrop.addEventListener('click', function (event) {
            if (event.target === backdrop) {
                window.closeThankYouModal();
            }
        });
    }

    return { modal: modal, backdrop: backdrop };
}

// QA_SUBSCRIPTIONS_END

function openPatientDetailsModal() {
    const modalEls = ensurePatientModalElements();
    const modal = modalEls.modal;
    const backdrop = modalEls.backdrop;
    if (!modal || !backdrop) return;
    if (!modal.querySelector('#modal-firstName')) {
        window.goBackToPatientDetails();
    } else {
        modal.style.display = 'block';
        backdrop.style.display = 'block';
        document.body.classList.add("no_scroll");
    }
}

// --- Submit routing (home-test → patient modal) ---
$('product-form [type="submit"]').on('click', function (e) {
    const flow = getCurrentCollectionFlow();
    const variantId = flow.variantId;
    const isClinicFlow = flow.isClinicFlow;
    const isMobileFlow = flow.isMobileFlow;
    const isHomeTestFlow = flow.isHomeTestFlow;

    const variantSku = getVariantSku();
    const productHandle = $('#product-handle').val();
    const realProductHandle = $('#real-product-handle').val();
    const eurofins_code = $('#eurofins_code').val();
    const productTitle = $('#product-title').val();
    const aptId = $('#aptId').val();
    const metafieldUpsells = getUpsellsFromMetafields() || [];

    logDiscountDebug('Product submit flow', {
        selected_variant_id: Number(variantId || 0),
        selected_collection_method: flow.collectionMethod || '',
        is_clinic_flow: !!isClinicFlow,
        is_book_at_home_flow: !!isMobileFlow,
        is_home_test_flow: !!isHomeTestFlow,
        product_handle: productHandle || '',
        product_title: productTitle || '',
        upsells_available_count: Array.isArray(metafieldUpsells) ? metafieldUpsells.length : 0,
    });

    if (isClinicFlow) {
        e.preventDefault();
        e.stopPropagation();

        if (!variantId) {
            alert('Please select a product variant.');
            return;
        }

        // Save to sessionStorage
        saveProductDataToSession({
            variant_id: variantId,
            variant_sku: variantSku,
            aptId: aptId,
            product_handle: productHandle,
            real_product_handle: realProductHandle,
            eurofinsCode: eurofins_code,
            product_title: productTitle,
        });
        saveUpsellsToSession();
        logDiscountDebug('Clinic flow session payload', {
            variant_id: Number(variantId),
            variant_sku: variantSku || '',
            apt_id: aptId || '',
            product_handle: productHandle || '',
            real_product_handle: realProductHandle || '',
            eurofins_code: eurofins_code || '',
        });

        window.location.href = '/pages/find-clinic';

    } else if (isMobileFlow) {
        e.preventDefault();
        e.stopPropagation();

        if (!variantId) {
            alert('Please select a product variant.');
            return;
        }

        const postCode = $('#preSearchFormobile_venous').val();

        // Save to sessionStorage
        saveProductDataToSession({
            variant_id: variantId,
            product_handle: productHandle,
            aptId: aptId,
            eurofinsCode: eurofins_code,
            product_title: productTitle,
            postCode: postCode,
            variant_sku: variantSku,
        });
        saveUpsellsToSession();
        logDiscountDebug('Book-at-home flow session payload', {
            variant_id: Number(variantId),
            variant_sku: variantSku || '',
            apt_id: aptId || '',
            product_handle: productHandle || '',
            eurofins_code: eurofins_code || '',
            postcode: postCode || '',
        });

        window.location.href = '/pages/check-mobile-availability';

    } else if (isHomeTestFlow) {
        e.preventDefault();
        e.stopPropagation();
        openPatientDetailsModal();
        return;
    }
});

// Safety net: if any native form submit still happens for home-test flows,
// intercept it and open the patient details modal instead of direct cart add.
document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (formEl) {
    if (formEl.dataset.patientModalGuardAttached === '1') return;
    formEl.dataset.patientModalGuardAttached = '1';
    formEl.addEventListener('submit', function (e) {
        if (window.__allowNativeAddToCartSubmit) return;
        const flow = getCurrentCollectionFlow();
        if (!flow.isHomeTestFlow) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        openPatientDetailsModal();
    }, true);
});

// --- Modal close & patient step (continueToAddToBasket) ---
window.closeThankYouModal = function () {
    window.__subscriptionStepActive = false;
    const modal = document.getElementById('thankYouModal');
    const backdrop = document.getElementById('modalBackdrop');
    if (modal) modal.style.display = 'none';
    if (backdrop) backdrop.style.display = 'none';
    // Clear temp patient data when closing
    window.tempPatientData = null;
    document.body.classList.remove("no_scroll");
};

window.continueToAddToBasket = async function (e) {
    // Prevent any default form submission
    if (e) {
        e.preventDefault();
        e.stopPropagation();
    }

    const firstNameInput = document.getElementById('modal-firstName');
    const lastNameInput = document.getElementById('modal-lastName');
    const dobInput = document.getElementById('modal-dob');
    const emailInput = document.getElementById('modal-email');
    const date1Input = document.getElementById('modal-pdate1');
    // const timeh1Input = document.getElementById('timeh1');
    // const timem1Input = document.getElementById('timem1');
    const timeampm1Input = document.querySelectorAll('input[name="ampm1"]');
    let selectedAmPm1 = '';
    const date2Input = document.getElementById('modal-pdate2');
    // const timeh2Input = document.getElementById('timeh2');
    // const timem2Input = document.getElementById('timem2');
    const timeampm2Input = document.querySelectorAll('input[name="ampm2"]');
    let selectedAmPm2 = '';
    const date3Input = document.getElementById('modal-pdate3');
    // const timeh3Input = document.getElementById('timeh3');
    // const timem3Input = document.getElementById('timem3');
    const timeampm3Input = document.querySelectorAll('input[name="ampm3"]');
    let selectedAmPm3 = '';
    const pmakerInputs = document.querySelectorAll('input[name="modal-pmaker"]');
    let selectedPmaker = '';
    const genderInputs = document.querySelectorAll('input[name="modal-gender"]');
    let selectedGender = '';

    genderInputs.forEach(function (input) {
        if (input.checked) {
            selectedGender = input.value;
        }
    });
    pmakerInputs.forEach(function (input) {
        if (input.checked) {
            selectedPmaker = input.value;
        }
    });
    timeampm1Input.forEach(function (input) {
        if (input.checked) {
            selectedAmPm1 = input.value;
        }
    });
    timeampm2Input.forEach(function (input) {
        if (input.checked) {
            selectedAmPm2 = input.value;
        }
    });
    timeampm3Input.forEach(function (input) {
        if (input.checked) {
            selectedAmPm3 = input.value;
        }
    });

    if (!firstNameInput.value) {
        alert('Please enter the patient\'s first name before continuing.');
        return;
    }
    if (!lastNameInput.value) {
        alert('Please enter the patient\'s last name before continuing.');
        return;
    }
    if (!dobInput.value) {
        alert('Please enter the patient\'s date of birth before continuing.');
        return;
    }

    if (!selectedGender) {
        alert('Please select the patient\'s gender before continuing.');
        return;
    }
    // Options for MRI Scan - Prt Body
    // if (emailInput && !emailInput.value) {
    //   alert('Please enter the patient\'s email address before continuing.');
    //   return;
    // }
    if (date1Input && !date1Input.value) {
        alert('Please enter the appointment preferred date before continuing.');
        return;
    }

    // if (date2Input && !date2Input.value) {
    //     alert('Please enter the patient\'s second preferred date 2 before continuing.');
    //     return;
    // }
    // if (date3Input && !date3Input.value) {
    //     alert('Please enter the patient\'s third preferred date 3 before continuing.');
    //     return;
    // }
    // if (pmakerInputs && selectedPmaker == '') {
    //   alert('Please select the patient\'s pace maker fitting option before continuing.');
    //   return;
    // }
    if (date1Input) {
        // Store patient details temporarily for later use
        window.tempPatientData = {
            firstName: firstNameInput.value,
            lastName: lastNameInput.value,
            dob: dobInput.value,
            gender: selectedGender,
            // email: emailInput.value,
            pdate1: date1Input.value,
            ptime1: selectedAmPm1,
            // pdate2: date2Input.value,
            // ptime2: selectedAmPm2,
            // pdate3: date3Input.value,
            // ptime3: selectedAmPm3,
            pmaker: selectedPmaker,
            mriScan: true
        };
    } else {
        // Store patient details temporarily for later use
        window.tempPatientData = {
            firstName: firstNameInput.value,
            lastName: lastNameInput.value,
            dob: dobInput.value,
            gender: selectedGender,
        };
    }


    // Save main variant data for subscription step (booking flow and product modal)
    const variantIdForSession = getSelectedVariantId();
    if (variantIdForSession) {
        const variantData = getMainProductVariantData(variantIdForSession);
        const selectedVariantPayload = getSelectedVariantPayload();
        const payloadSellingPlans = getSellingPlansFromVariantPayload(selectedVariantPayload);
        const pickerDomVariantData = getMainVariantDataFromSelectedPickerDom(variantIdForSession);
        const purchaseOptionsDomData = getMainVariantDataFromPurchaseOptionsDom(variantIdForSession);
        const productJsonVariantData = await getMainVariantDataFromProductJson(variantIdForSession);
        const productTitleEl = document.getElementById('product-title');
        const productTitle = productTitleEl ? productTitleEl.value : '';
        if (variantData) {
            sessionStorage.setItem('main_variant_title', variantData.title || '');
            sessionStorage.setItem('main_variant_selling_plan_id', String(variantData.selling_plan_id || ''));
            sessionStorage.setItem('main_variant_selling_plans', JSON.stringify(variantData.selling_plans || []));
            sessionStorage.setItem('main_variant_price', String(variantData.price || ''));
        } else if (selectedVariantPayload) {
            // Fallback for templates where #main-product-variants data is unavailable/stale.
            const payloadPrice = selectedVariantPayload.price ? (Number(selectedVariantPayload.price) / 100) : '';
            sessionStorage.setItem('main_variant_title', selectedVariantPayload.option1 || selectedVariantPayload.title || '');
            sessionStorage.setItem('main_variant_price', String(payloadPrice || ''));
            if (payloadSellingPlans.length) {
                sessionStorage.setItem('main_variant_selling_plan_id', String(payloadSellingPlans[0].id || ''));
                sessionStorage.setItem('main_variant_selling_plans', JSON.stringify(payloadSellingPlans));
            }
            if (pickerDomVariantData && Array.isArray(pickerDomVariantData.selling_plans) && pickerDomVariantData.selling_plans.length) {
                sessionStorage.setItem('main_variant_selling_plan_id', String(pickerDomVariantData.selling_plan_id || ''));
                sessionStorage.setItem('main_variant_selling_plans', JSON.stringify(pickerDomVariantData.selling_plans || []));
                if (!payloadPrice && pickerDomVariantData.price) {
                    sessionStorage.setItem('main_variant_price', String(pickerDomVariantData.price));
                }
            }
        } else if (pickerDomVariantData) {
            sessionStorage.setItem('main_variant_title', pickerDomVariantData.title || '');
            sessionStorage.setItem('main_variant_selling_plan_id', String(pickerDomVariantData.selling_plan_id || ''));
            sessionStorage.setItem('main_variant_selling_plans', JSON.stringify(pickerDomVariantData.selling_plans || []));
            sessionStorage.setItem('main_variant_price', String(pickerDomVariantData.price || ''));
        } else if (purchaseOptionsDomData) {
            sessionStorage.setItem('main_variant_title', purchaseOptionsDomData.title || '');
            sessionStorage.setItem('main_variant_selling_plan_id', String(purchaseOptionsDomData.selling_plan_id || ''));
            sessionStorage.setItem('main_variant_selling_plans', JSON.stringify(purchaseOptionsDomData.selling_plans || []));
            sessionStorage.setItem('main_variant_price', String(purchaseOptionsDomData.price || ''));
            if (productJsonVariantData && productJsonVariantData.selling_plans.length &&
                (!purchaseOptionsDomData.selling_plans || productJsonVariantData.selling_plans.length > purchaseOptionsDomData.selling_plans.length)) {
                sessionStorage.setItem('main_variant_selling_plan_id', String(productJsonVariantData.selling_plan_id || ''));
                sessionStorage.setItem('main_variant_selling_plans', JSON.stringify(productJsonVariantData.selling_plans || []));
                if (!purchaseOptionsDomData.price && productJsonVariantData.price) {
                    sessionStorage.setItem('main_variant_price', String(productJsonVariantData.price));
                }
            }
        } else if (productJsonVariantData) {
            sessionStorage.setItem('main_variant_title', productJsonVariantData.title || '');
            sessionStorage.setItem('main_variant_selling_plan_id', String(productJsonVariantData.selling_plan_id || ''));
            sessionStorage.setItem('main_variant_selling_plans', JSON.stringify(productJsonVariantData.selling_plans || []));
            sessionStorage.setItem('main_variant_price', String(productJsonVariantData.price || ''));
        } else {
        }
        sessionStorage.setItem('variant_id', String(variantIdForSession));
        if (productTitle) sessionStorage.setItem('product_title', productTitle);
    }

    // Check if upsells are available
    const upsells = getUpsellsFromMetafields();

    if (upsells && Array.isArray(upsells) && upsells.length > 0) {
        // Show upsells as step 2 in the same modal (wizard style)
        showUpsellStep(upsells);
        return; // IMPORTANT: Stop execution here
    }

    // No upsells: show subscription step when current flow supports subscriptions
    // and the main product has selling plans.
    const flow = getCurrentCollectionFlow();
    const flowSupportsSubscription = flow.isHomeTestFlow || flow.isClinicFlow || flow.isMobileFlow;
    if (flowSupportsSubscription) {
        let mainPlans = [];
        try {
            const s = sessionStorage.getItem('main_variant_selling_plans');
            if (s) mainPlans = JSON.parse(s);
        } catch (e) {
        }
        if (mainPlans && mainPlans.length > 0) {
            showSubscriptionStepInModal([], true); // true = from no-upsells path, Back goes to patient details
            return;
        }
    }

    // No upsells and no subscription step needed, proceed directly to add to cart
    const sectionEl = document.querySelector('[data-section-id]');
    const sectionId = sectionEl?.dataset.sectionId || null;
    const productSubmitButtonId = "ProductSubmitButton-" + sectionId;
    if (date1Input) {
        // if(timeh1Input && timem1Input && timeampm1Input){
        //   var mtime1 = timeh1Input.value+":"+timem1Input.value+""+timeampm1Input.value;
        // }
        // if(timeh2Input && timem2Input && timeampm2Input){
        //   var mtime2 = timeh2Input.value+":"+timem2Input.value+""+timeampm2Input.value;
        // }
        // if(timeh3Input && timem3Input && timeampm3Input){
        //   var mtime3 = timeh3Input.value+":"+timem3Input.value+""+timeampm3Input.value;
        // }
        // if (timeampm1Input) {
        //     var mtime1 = timeampm1Input.value;
        // }
        // if (timeampm2Input) {
        //     var mtime2 = timeampm2Input.value;
        // }
        // if (timeampm3Input) {
        //     var mtime3 = timeampm3Input.value;
        // }

        // Create hidden inputs to pass the patient details as product properties
        addPropertiesToForm(firstNameInput.value, lastNameInput.value, dobInput.value, selectedGender, date1Input.value, selectedAmPm1, selectedPmaker);
    } else {
        addPropertiesToForm(firstNameInput.value, lastNameInput.value, dobInput.value, selectedGender);
    }
    // Validate variant selection using helper function
    const variantId = getSelectedVariantId();
    if (!variantId) {
        alert('Please select a product variant.');
        return;
    }

    closeThankYouModal();
    const submitButton = document.getElementById(productSubmitButtonId);
    if (submitButton && submitButton.closest('form')) {
        submitButton.closest('form').submit();
    } else {
        console.error('Submit button or form not found');
        alert('Unable to proceed. Please refresh the page and try again.');
    }
};

function addPropertiesToForm(firstName, lastName, dob, gender, pdate1, ptime1, pmaker) {
    // Remove any existing property inputs
    const existingInputs = document.querySelectorAll('input[name^="properties["]');
    existingInputs.forEach(input => input.remove());

    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) {
        console.error('Add to cart form not found');
        return;
    }

    // Helper function to create and append hidden input
    const addHiddenInput = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    };

    // Add patient details
    addHiddenInput('properties[First Name]', firstName);
    addHiddenInput('properties[Last Name]', lastName);
    addHiddenInput('properties[Date of Birth]', dob.split('-').reverse().join('/'));
    addHiddenInput('properties[Gender]', gender);
    // if(email){
    //   addHiddenInput('properties[Email]', email);
    // }
    if (pdate1) {
        addHiddenInput('properties[Preferred Date 1]', pdate1.split('-').reverse().join('/') + " " + ptime1);
    }
    // if (pdate2) {
    //     addHiddenInput('properties[Preferred Date 2]', pdate2.split('-').reverse().join('/') + " " + ptime2);
    // }
    // if (pdate3) {
    //     addHiddenInput('properties[Preferred Date 3]', pdate3.split('-').reverse().join('/') + " " + ptime3);
    // }
    if (pmaker) {
        addHiddenInput('properties[Pace-Maker Fitted?]', pmaker);
    }

    // Add product identifiers if available
    const productHandle = $('#product-handle').val();
    const eurofins_code = $('#eurofins_code').val();

    if (productHandle && productHandle !== 'undefined') {
        addHiddenInput('properties[product_id]', productHandle);
    }

    if (eurofins_code && eurofins_code !== 'undefined') {
        addHiddenInput('properties[product_code]', eurofins_code);
    }
}

// --- Upsell step ---
window.showUpsellStep = function (upsells) {
    const modal = document.getElementById('thankYouModal');
    const modalContent = modal ? modal.querySelector('.thank-you-modal__content') : null;

    if (!modal || !modalContent) {
        console.error('Modal or modalContent not found!');
        return;
    }

    // Create step 2 content (upsells)
    let upsellListHtml = '';
    let hasUpsells = false;

    upsells.forEach((product, index) => {
        let skip = 1;
        let product_id;
        let product_price;
        let product_discount;
        let selectedVariant = null;

        // If product has variants, find the appropriate variant for home test kits
        // Follow same pattern as section-book-appointment.js
        if (product.title.toLowerCase().includes('gp consultation') || product.title.toLowerCase().includes('mri')) {
            // For GP consultation and MRI, use first variant
            if (product.variants && product.variants.length > 0) {
                selectedVariant = product.variants[0];
                skip = 0;
                product_id = selectedVariant.id;
                product_price = parsePrice(product.price);
                product_discount = 0;
            }
        } else {
            // For other products, try to find home test variant first
            // Apply configurable discount for home test upsells
            if (product.variants && product.variants.length > 0) {
                product.variants.forEach(variant => {
                    if (isFingerPrickVariantTitle(variant.title)) {
                        selectedVariant = variant;
                        skip = 0;
                        product_id = variant.id;
                        product_price = parsePrice(variant.price) - HOME_TEST_UPSELL_DISCOUNT;
                        product_discount = HOME_TEST_UPSELL_DISCOUNT;
                    }
                });
                // Fallback for products whose upsell variants don't use finger-prick titles.
                // Keep upsell visible by using the first available variant (one-time by default if no plans).
                if (!selectedVariant) {
                    selectedVariant = product.variants[0];
                    skip = 0;
                    product_id = selectedVariant.id;
                    product_price = parsePrice(selectedVariant.price);
                    product_discount = 0;
                }
            }
        }

        if (skip === 0 && product_id && selectedVariant) {
            hasUpsells = true;
            const checkboxId = `home_upsell_${ index }`;
            const productImage = product.image || '';
            const productImageAlt = product.image_alt || product.title || '';
            const variantTitle = (typeof selectedVariant.title === 'string') ? selectedVariant.title.replace(/"/g, '&quot;') : '';
            const sellingPlanId = selectedVariant.selling_plan_id || '';
            const sellingPlans = selectedVariant.selling_plans || [];
            const sellingPlansJson = JSON.stringify(sellingPlans).replace(/"/g, '&quot;');

            upsellListHtml += `
          <div class="bolton-item" style="margin-bottom: 16px; display: flex; align-items: flex-start; gap: 12px;">
            <input 
              class="bolt_on_option_box boltonCheckbox" 
              type="checkbox" 
              style="width: 20px; height: 20px; vertical-align: middle; margin-top: 2px; flex-shrink: 0;" 
              id="${ checkboxId }" 
              value="${ product_id }" 
              data-desc_title="${ (product.title || '').replace(/"/g, '&quot;') }"
              data-handle="${ product.handle }"
              data-eurofins_code="${ product.eurofins_code }"
              data-price="${ product_price }"
              data-original_price="${ parsePrice(selectedVariant.price) }"
              data-discount_amount="${ product_discount || 0 }"
              data-variant_title="${ variantTitle }"
              data-selling_plan_id="${ sellingPlanId }"
              data-selling_plans="${ sellingPlansJson }">
            ${ productImage ? `<img src="${ productImage }" alt="${ productImageAlt }" style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px; flex-shrink: 0;" loading="lazy">` : '' }
            <label for="${ checkboxId }" style="flex: 1; cursor: pointer; display: flex; flex-direction: column; justify-content: center;">
              <span style="font-weight: 500; margin-bottom: 4px;">${ product.title }</span>
              <span style="font-size: 1.5rem;">&pound;${ product_price.toFixed(2) }</span>
              ${ product_discount > 0 ? `<i style="font-size: 1rem; color: #666;">(&pound;${ product_discount.toFixed(2) } off regular price)</i>` : '' }
            </label>
          </div>
        `;
        }
    });
    if (hasUpsells && upsellListHtml.length > 0) {
        // Ensure modal is visible
        modal.style.display = 'block';
        const backdrop = document.getElementById('modalBackdrop');
        if (backdrop) backdrop.style.display = 'block';

        // Replace modal content with step 2 (upsells)
        modalContent.innerHTML = `
        <div class="product-form__firstName" style="margin-bottom: 24px; font-weight:700; text-align: center;">
          <p>We Recommend Adding</p>
        </div>
        <div id="upsellList" style="margin-bottom: 24px;">
          ${ upsellListHtml }
        </div>
        <button type="button" class="inter_btn" onclick="goBackToPatientDetails()" style="margin-top: 16px; margin-bottom: 12px; display:block; border:0; width:100%; background: #f0f0f0; color: #333; padding: 12px; cursor: pointer; justify-content: center;">Back</button>
        <button type="button" class="inter_btn" id="continueToCheckoutButton" style="margin-top: 16px; display:block; border:0; width:100%; cursor: pointer; justify-content: center;">Continue</button>
      `;

        // Bind explicit handler after render to avoid any stale inline/global resolution issues.
        const continueBtn = modalContent.querySelector('#continueToCheckoutButton');
        if (continueBtn) {
            continueBtn.addEventListener('click', function (event) {
                event.preventDefault();
                event.stopPropagation();
                if (event.stopImmediatePropagation) event.stopImmediatePropagation();
                window.onContinueFromUpsellStep();
                return false;
            });
        }
    } else {
        // No upsells to show, proceed directly to checkout
        continueToCheckoutWithUpsells();
    }
};

// Go back to step 1 (patient details)
window.goBackToPatientDetails = function () {
    window.__subscriptionStepActive = false;
    const modal = document.getElementById('thankYouModal');
    if (!modal) return;

    const modalContent = modal.querySelector('.thank-you-modal__content');
    if (!modalContent) return;

    const patientData = window.tempPatientData || {};

    // Restore step 1 content (patient details form)
    modalContent.innerHTML = `
      <div class="product-form_heading" style="margin-bottom: 24px;font-weight:700;">
        <p>Please enter the patient's details</p>
      </div>
      <div class="product-form__firstName" style="margin-bottom: 20px;">
        <label for="modal-firstName" class="label" style="display: block; margin-bottom: 8px;">First Name:</label>
        <input type="text" id="modal-firstName" name="modal-firstName" required="" tabindex="1" enterkeyhint="next" class="input input--text" style="width: 100%; padding: 8px;font-family: Inter, sans-serif;" value="${ patientData.firstName || '' }">
      </div>
      <div class="product-form__lastName" style="margin-bottom: 20px;">
        <label for="modal-lastName" class="label" style="display: block; margin-bottom: 8px;">Last Name:</label>
        <input type="text" id="modal-lastName" name="modal-lastName" required="" tabindex="2" enterkeyhint="next" class="input input--text" style="width: 100%; padding: 8px;font-family: Inter, sans-serif;" value="${ patientData.lastName || '' }">
      </div>
      <div class="product-form__dob" style="margin-bottom: 20px;">
        <label for="modal-dob" class="label" style="display: block; margin-bottom: 8px;">Date of Birth:</label>
        <input type="date" id="modal-dob" name="modal-dob" required="" tabindex="3" enterkeyhint="next" class="input input--text" style="width: 100%; padding: 8px;font-family: Inter, sans-serif;" value="${ patientData.dob || '' }">
      </div>
      <div class="product-form__gender" style="margin-bottom: 20px;">
        <label class="label" style="display: block; margin-bottom: 8px;">Gender:</label>
        <label class="radio_inp label label--inline" for="gender-male" >
            <input type="radio" id="gender-male" name="modal-gender" tabindex="4" value="Male" required="" ${ patientData.gender === 'Male' ? 'checked' : '' }>
            Male
        </label>
        <label class="radio_inp label label--inline" for="gender-female">
            <input type="radio" id="gender-female" name="modal-gender" tabindex="5" value="Female" required="" ${ patientData.gender === 'Female' ? 'checked' : '' }>
            Female
        </label>
        <label class="radio_inp label label--inline" for="gender-other">
            <input type="radio" id="gender-other" name="modal-gender" tabindex="6" value="Prefer not to say" required="" ${ patientData.gender === 'Prefer not to say' ? 'checked' : '' }>
            Prefer not to say
        </label>
      </div>`;
    if(patientData.mriScan === true){
      modalContent.innerHTML +=  `<div class="pref_appt_head"><p>Appointment Preference</p></div>
                <div class="pref_appt appt1">
                    <div class="product-form__date">
                      <label for="modal-pdate1" class="label" style="display: block; margin-bottom: 8px;">Preferred Date</label>
                      <input type="date" id="modal-pdate1" name="modal-pdate1" tabindex="3" enterkeyhint="next" class="input input--text" style="width: 100%; padding: 8px;font-family: Inter, sans-serif;" value="${ patientData.pdate1 || '' }">
                    </div>
                    <div class="product-form__time">
                      <label for="modal-time1" class="label" style="display: block; margin-bottom: 8px;">Time preference</label>
                      <div class="popup_time time1">
                        <label class="radio_inp label label--inline" for="time-am1">
                          <input type="radio" id="time-am1" name="ampm1" tabindex="5" value="AM" required="" ${ patientData.ptime1 === 'AM' ? 'checked' : '' }>
                          AM
                        </label>
                        <label class="radio_inp label label--inline" for="time-pm1">
                          <input type="radio" id="time-pm1" name="ampm1" tabindex="5" value="PM" required="" ${ patientData.ptime1 === 'PM' ? 'checked' : '' }>
                          PM
                        </label>
                        <label class="radio_inp label label--inline" for="time-any1">
                          <input type="radio" id="time-any1" name="ampm1" tabindex="5" value="ANY" required="" ${ patientData.ptime1 === 'ANY' ? 'checked' : '' }>
                          Any
                        </label>
                      </div>
                    </div>
                    <div class="product-form__appoint_note inter_para_16">95% of the appointments are booked on the preferred date.</div>
                  </div>
                  <div class="pref_appt appt2 hidden">
                    <span>Preferred appointment 2</span>
                    <div class="product-form__date" style="margin-bottom: 20px;">
                      <label for="modal-pdate2" class="label" style="display: block; margin-bottom: 8px;">Preferred Date</label>
                      <input type="date" id="modal-pdate2" name="modal-pdate2"  tabindex="3" enterkeyhint="next" class="input input--text" style="width: 100%; padding: 8px;font-family: Inter, sans-serif;" value="${ patientData.pdate2 || '' }">
                    </div>
                    <div class="product-form__time" style="margin-bottom: 24px;">
                      <label for="modal-time1" class="label" style="display: block; margin-bottom: 8px;">Time preference</label>
                      <div class="popup_time time1">
                        <div>
                          <input type="radio" id="time-am2" name="ampm2" tabindex="5" value="AM" required="" ${ patientData.ptime2 === 'AM' ? 'checked' : '' }>
                          <label for="time-am2" class="label label--inline">AM</label>
                        </div>
                        <div>
                          <input type="radio" id="time-pm2" name="ampm2" tabindex="5" value="PM" required="" ${ patientData.ptime2 === 'PM' ? 'checked' : '' }>
                          <label for="time-pm2" class="label label--inline">PM</label>
                        </div>
                        <div>
                          <input type="radio" id="time-any2" name="ampm2" tabindex="5" value="ANY" required="" ${ patientData.ptime2 === 'ANY' ? 'checked' : '' }>
                          <label for="time-any2" class="label label--inline">Any</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pref_appt appt2 hidden">
                    <span>Preferred appointment 3</span>
                    <div class="product-form__date" style="margin-bottom: 20px;">
                      <label for="modal-pdate3" class="label" style="display: block; margin-bottom: 8px;">Preferred Date</label>
                      <input type="date" id="modal-pdate3" name="modal-pdate3"  tabindex="3" enterkeyhint="next" class="input input--text" style="width: 100%; padding: 8px;font-family: Inter, sans-serif;" value="${ patientData.pdate3 || '' }">
                    </div>
                    <div class="product-form__time" style="margin-bottom: 24px;">
                      <label for="modal-time1" class="label" style="display: block; margin-bottom: 8px;">Time preference</label>
                      <div class="popup_time time1">
                        <div>
                          <input type="radio" id="time-am" name="ampm3" tabindex="5" value="AM" required="" ${ patientData.ptime3 === 'AM' ? 'checked' : '' }>
                          <label for="time-am" class="label label--inline">AM</label>
                        </div>
                        <div> 
                          <input type="radio" id="time-pm" name="ampm3" tabindex="5" value="PM" required="" ${ patientData.ptime3 === 'PM' ? 'checked' : '' }>
                          <label for="time-pm" class="label label--inline">PM</label>
                        </div>
                        <div>
                          <input type="radio" id="time-any" name="ampm3" tabindex="5" value="ANY" required="" ${ patientData.ptime3 === 'ANY' ? 'checked' : '' }>
                          <label for="time-any" class="label label--inline">Any</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="product-form__pmaker" style="margin-bottom: 20px;">
                    <label class="label" style="display: block; margin-bottom: 8px;">Pace-Maker Fitted?</label>
                    <label class="radio_inp label label--inline" for="gender-yes">
                      <input type="radio" id="gender-yes" name="modal-pmaker" tabindex="4" value="Yes" ${ patientData.pmaker === 'Yes' ? 'checked' : '' }>
                      Yes
                    </label>
                    <label class="radio_inp label label--inline" for="gender-no">
                      <input type="radio" id="gender-no" name="modal-pmaker" tabindex="5" value="No" ${ patientData.pmaker === 'No' ? 'checked' : '' }>
                      No
                    </label>
                  </div>`;  
    }
    modalContent.innerHTML +=  `<button type="button" class="inter_btn" id="addToBasketButton" onclick="continueToAddToBasket(event)"  tabindex="6" style="margin-top: 16px; display:block;border:0; width:100%">Continue</button>
    `;
};

// --- Subscription step (modal); fromNoUpsells = Back returns to patient details ---
window.showSubscriptionStepInModal = function (selectedUpsells, fromNoUpsells, options) {
    window.__subscriptionStepActive = true;
    const modal = document.getElementById('thankYouModal');
    const modalContent = modal ? modal.querySelector('.thank-you-modal__content') : null;
    if (!modal || !modalContent) {
        return;
    }

    window.__modalSelectedUpsells = selectedUpsells || [];
    window.__modalFromNoUpsells = !!fromNoUpsells;
    var modalOptions = options || {};
    var forceUpsellsOneTime = !!modalOptions.forceUpsellsOneTime;

    const mainVariantTitle = sessionStorage.getItem('main_variant_title') || '';
    const mainVariantSellingPlanId = sessionStorage.getItem('main_variant_selling_plan_id') || '';
    let mainVariantSellingPlans = [];
    try {
        const s = sessionStorage.getItem('main_variant_selling_plans');
        if (s) mainVariantSellingPlans = JSON.parse(s);
    } catch (e) {
    }
    let mainPrice = parsePrice(sessionStorage.getItem('main_variant_price') || '0');
    const productTitle = sessionStorage.getItem('product_title') || 'Main product';
    // Fallback: if session is stale/missing, read current selected variant directly.
    if (!mainVariantSellingPlans.length) {
        const currentVariant = getMainProductVariantData(getSelectedVariantId());
        if (currentVariant && Array.isArray(currentVariant.selling_plans) && currentVariant.selling_plans.length) {
            mainVariantSellingPlans = currentVariant.selling_plans;
        }
        if (!mainPrice && currentVariant && currentVariant.price) {
            mainPrice = parsePrice(currentVariant.price);
        }
        if (!mainVariantSellingPlans.length) {
            const selectedVariantPayload = getSelectedVariantPayload();
            const payloadSellingPlans = getSellingPlansFromVariantPayload(selectedVariantPayload);
            if (payloadSellingPlans.length) {
                mainVariantSellingPlans = payloadSellingPlans;
            }
            if (!mainPrice && selectedVariantPayload && selectedVariantPayload.price) {
                mainPrice = parsePrice(Number(selectedVariantPayload.price) / 100);
            }
        }
        if (!mainVariantSellingPlans.length) {
            const pickerDomVariantData = getMainVariantDataFromSelectedPickerDom(getSelectedVariantId());
            if (pickerDomVariantData && Array.isArray(pickerDomVariantData.selling_plans) && pickerDomVariantData.selling_plans.length) {
                mainVariantSellingPlans = pickerDomVariantData.selling_plans;
            }
            if (!mainPrice && pickerDomVariantData && pickerDomVariantData.price) {
                mainPrice = parsePrice(pickerDomVariantData.price);
            }
            if (!mainVariantSellingPlans.length || !mainPrice) {
                const purchaseOptionsDomData = getMainVariantDataFromPurchaseOptionsDom(getSelectedVariantId());
                if (!mainVariantSellingPlans.length && purchaseOptionsDomData && Array.isArray(purchaseOptionsDomData.selling_plans)) {
                    mainVariantSellingPlans = purchaseOptionsDomData.selling_plans;
                }
                if (!mainPrice && purchaseOptionsDomData && purchaseOptionsDomData.price) {
                    mainPrice = parsePrice(purchaseOptionsDomData.price);
                }
                if ((!mainVariantSellingPlans.length || mainVariantSellingPlans.length === 1)) {
                    const cached = window.__productJsonVariantDataCache && window.__productJsonVariantDataCache[getSelectedVariantId()];
                    if (cached && cached.selling_plans.length &&
                        (!mainVariantSellingPlans.length || cached.selling_plans.length > mainVariantSellingPlans.length)) {
                        mainVariantSellingPlans = cached.selling_plans;
                    }
                    if (!mainPrice && cached && cached.price) {
                        mainPrice = parsePrice(cached.price);
                    }
                }
            }
        }
    }
    if (!mainPrice) {
        const selectedVariantPayload = getSelectedVariantPayload();
        if (selectedVariantPayload && selectedVariantPayload.price) {
            mainPrice = parsePrice(Number(selectedVariantPayload.price) / 100);
        }
    }

    function formatMoney(value) {
        return '&pound;' + parsePrice(value).toFixed(2);
    }

    const shared = window.GbcSubscriptionShared;
    if (!shared || typeof shared.buildSubscriptionStepHtml !== 'function') {
        console.error('GbcSubscriptionShared.buildSubscriptionStepHtml is required');
        return;
    }
    const html = shared.buildSubscriptionStepHtml({
        wrapInContainer: true,
        withOptionHeader: true,
        planButtonStyle: 'split',
        requireMainSellingPlanId: false,
        heading: 'Choose purchase option',
        productTitle: productTitle,
        mainPrice: mainPrice,
        mainVariantSellingPlanId: mainVariantSellingPlanId,
        mainVariantSellingPlans: mainVariantSellingPlans,
        forceUpsellsOneTime: forceUpsellsOneTime,
        upsells: (window.__modalSelectedUpsells || []),
        actionsHtml:
            '<div class="subscription-step__actions">' +
            '<button type="button" class="subscription-step__back" id="subscription-step-modal-back">Back</button>' +
            '<button type="button" class="subscription-step__continue" id="subscription-step-modal-continue">Continue</button>' +
            '</div>',
    });

    modalContent.innerHTML = html;
    shared.bindOptionSelection(modalContent);
    shared.bindPlanButtons(modalContent, {
        onPlanChange: function (ctx) {
            const priceNode = ctx.subscribeOption.querySelector('.subscription-step__discounted-price');
            if (priceNode && ctx.button.dataset.planPrice) {
                priceNode.innerHTML = formatMoney(ctx.button.dataset.planPrice);
            }
            const firstBenefit = ctx.subscribeOption.querySelector('.subscription-step__option-benefits li');
            if (firstBenefit && ctx.button.dataset.planDiscount) {
                firstBenefit.textContent = 'Save ' + ctx.button.dataset.planDiscount + '%';
            }
        },
    });

    document.getElementById('subscription-step-modal-back').addEventListener('click', function () {
        if (window.__modalFromNoUpsells) {
            window.goBackToPatientDetails();
        } else {
            window.showUpsellStep(getUpsellsFromMetafields());
        }
    });

    document.getElementById('subscription-step-modal-continue').addEventListener('click', function () {
        window.continueToCheckoutWithSubscriptions();
    });
};

window.continueToCheckoutWithSubscriptions = async function () {
    window.__subscriptionStepActive = false;
    const modalContent = document.querySelector('.thank-you-modal__content');
    if (!modalContent) return;

    const shared = window.GbcSubscriptionShared;
    if (!shared || typeof shared.collectChoices !== 'function') {
        console.error('GbcSubscriptionShared.collectChoices is required');
        return;
    }
    const choices = shared.collectChoices(modalContent);

    const variantId = getSelectedVariantId();
    if (!variantId) {
        alert('Please select a product variant.');
        return;
    }

    const patientData = window.tempPatientData || {};
    const productHandle = $('#product-handle').val();
    const eurofins_code = $('#eurofins_code').val();

    const items = [{
        id: variantId,
        quantity: 1,
        properties: createCartItemProperties(patientData, productHandle, eurofins_code),
        selling_plan: choices.main ? choices.main : undefined,
    }];
    if (!items[0].selling_plan) delete items[0].selling_plan;

    const selectedUpsells = window.__modalSelectedUpsells || [];
    selectedUpsells.forEach(function (u) {
        // Match subscription choice by variant_id; upsells without choices stay one-time
        const planChoice = choices.upsells.find(function (c) {
            return c.variant_id === Number(u.id);
        }) || null;
        const sellingPlanId = planChoice && planChoice.selling_plan_id ? planChoice.selling_plan_id : null;
        const item = {
            id: Number(u.id),
            quantity: 1,
            properties: createCartItemProperties(patientData, u.product_id, u.eurofins_code),
        };
        if (sellingPlanId) item.selling_plan = sellingPlanId;
        items.push(item);
    });

    closeThankYouModal();
    window.__modalSelectedUpsells = null;
    window.__modalFromNoUpsells = null;

    try {
        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items }),
            credentials: 'same-origin',
        });
        if (!res.ok) {
            const errText = await res.text();
            console.error('Add to cart failed:', errText);
            alert('Could not add item to cart.');
            return;
        }
        window.location.href = '/cart';
    } catch (e) {
        console.error('Error adding to cart:', e);
        alert('Something went wrong adding the item to cart.');
    }
};

// --- Upsell → checkout or subscription step ---
window.onContinueFromUpsellStep = function () {
    const selectedUpsells = [];
    document.querySelectorAll('.bolt_on_option_box:checked').forEach(function (checkbox) {
        let sellingPlans = [];
        try {
            if (checkbox.dataset.selling_plans) sellingPlans = JSON.parse(checkbox.dataset.selling_plans.replace(/&quot;/g, '"'));
        } catch (e) {
        }
        selectedUpsells.push({
            id: checkbox.value,
            title: checkbox.dataset.desc_title,
            price: checkbox.dataset.price,
            original_price: checkbox.dataset.original_price || checkbox.dataset.price,
            discount_amount: checkbox.dataset.discount_amount,
            product_id: checkbox.dataset.handle,
            eurofins_code: checkbox.dataset.eurofins_code,
            variant_title: checkbox.dataset.variant_title || '',
            selling_plan_id: checkbox.dataset.selling_plan_id || '',
            selling_plans: sellingPlans,
        });
    });

    let mainVariantTitle = sessionStorage.getItem('main_variant_title') || '';
    const currentVariantId = getSelectedVariantId();
    const currentVariantData = getMainProductVariantData(currentVariantId);
    if (currentVariantData && currentVariantData.title) {
        mainVariantTitle = currentVariantData.title;
        sessionStorage.setItem('main_variant_title', mainVariantTitle);
    }
    const flow = getCurrentCollectionFlow();
    let mainPlans = (currentVariantData && currentVariantData.selling_plans) || [];
    if (!mainPlans.length) {
        try {
            const s = sessionStorage.getItem('main_variant_selling_plans');
            if (s) mainPlans = JSON.parse(s);
        } catch (e) {
        }
    }
    const hasMainPlans = Array.isArray(mainPlans) && mainPlans.length > 0;
    const hasUpsellPlans = selectedUpsells.some(function (u) {
        return u.selling_plans && u.selling_plans.length > 0;
    });
    var showSubscription = false;
    var forceUpsellsOneTime = false;
    if (flow.isClinicFlow || flow.isMobileFlow) {
        showSubscription = hasMainPlans;
        forceUpsellsOneTime = true;
    } else if (flow.isHomeTestFlow) {
        showSubscription = hasMainPlans || hasUpsellPlans;
    }
    if (showSubscription) {
        window.__subscriptionStepActive = true;
        window.showSubscriptionStepInModal(selectedUpsells, false, { forceUpsellsOneTime: forceUpsellsOneTime });
    } else {
        window.__subscriptionStepActive = false;
        window.continueToCheckoutWithUpsells(selectedUpsells);
    }
};

window.continueToCheckoutWithUpsells = async function (selectedUpsellsFromCaller) {
    if (window.__subscriptionStepActive) {
        return;
    }
    // Use passed array if provided (from onContinueFromUpsellStep), otherwise collect from DOM
    let selectedUpsells = selectedUpsellsFromCaller;
    if (!selectedUpsells || !Array.isArray(selectedUpsells)) {
        selectedUpsells = [];
        document.querySelectorAll('.bolt_on_option_box:checked').forEach(function (checkbox) {
            selectedUpsells.push({
                id: checkbox.value,
                title: checkbox.dataset.desc_title,
                price: checkbox.dataset.price,
                product_id: checkbox.dataset.handle,
                eurofins_code: checkbox.dataset.eurofins_code,
            });
        });
    }

    // Safety net: if upsell step is visible and at least one product has plans, route to subscription first.
    const modal = document.getElementById('thankYouModal');
    const isUpsellStepVisible = !!(modal && modal.style.display === 'block' && modal.querySelector('#upsellList'));
    if (isUpsellStepVisible) {
        const flow = getCurrentCollectionFlow();
        const currentVariantData = getMainProductVariantData(getSelectedVariantId());
        const mainPlans = (currentVariantData && currentVariantData.selling_plans) || [];
        const hasMainPlans = Array.isArray(mainPlans) && mainPlans.length > 0;
        const hasUpsellPlans = selectedUpsells.some(function (u) {
            return u.selling_plans && u.selling_plans.length > 0;
        });
        var showSubscription = false;
        var forceUpsellsOneTime = false;
        if (flow.isClinicFlow || flow.isMobileFlow) {
            showSubscription = hasMainPlans;
            forceUpsellsOneTime = true;
        } else if (flow.isHomeTestFlow) {
            showSubscription = hasMainPlans || hasUpsellPlans;
        }
        if (showSubscription) {
            window.showSubscriptionStepInModal(selectedUpsells, false, { forceUpsellsOneTime: forceUpsellsOneTime });
            return;
        }
    }

    // Get the main product variant ID using helper function
    const variantId = getSelectedVariantId();

    if (!variantId) {
        console.error('Could not find variant ID. Debug info:', {
            selectedVariantsScript: !!document.querySelector('[data-selected-variant]'),
            checkedRadios: $('input[type="radio"]:checked').length,
            variantInput: !!document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]'),
            variantInputValue: document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value,
        });
        alert('Please select a product variant.');
        return;
    }
    const productHandle = $('#product-handle').val();
    const eurofins_code = $('#eurofins_code').val();
    const sellingPlan = document.querySelector('form[data-type="add-to-cart-form"] input[name="selling_plan"]')?.value;
    // Get patient data
    const patientData = window.tempPatientData || {};

    // Build items array for cart
    const items = [{
        id: variantId,
        quantity: 1,
        properties: createCartItemProperties(patientData, productHandle, eurofins_code),
    }];
    if (sellingPlan) items[0].selling_plan = Number(sellingPlan);

    // Add selected upsells
    selectedUpsells.forEach(u => {
        items.push({
            id: Number(u.id),
            quantity: 1,
            properties: createCartItemProperties(patientData, u.product_id, u.eurofins_code),
        });
    });

    // Close the modal now (after collecting data)
    closeThankYouModal();

    // Add to cart
    try {
        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify({ items }),
            credentials: 'same-origin',
        });

        if (!res.ok) {
            const errText = await res.text();
            console.error('Add to cart failed:', errText);
            alert('Could not add item to cart.');
            return;
        }

        // Redirect to cart (not checkout)
        window.location.href = '/cart';
    } catch (e) {
        console.error('Error adding to cart:', e);
        alert('Something went wrong adding the item to cart.');
    }
};

// Modal close handlers
document.getElementById('modalBackdrop')?.addEventListener('click', function (event) {
    if (event.target === this) {
        const thankYouModal = document.getElementById('thankYouModal');
        if (thankYouModal && thankYouModal.style.display === 'block') {
            closeThankYouModal();
        }
    }
});

document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
        const thankYouModal = document.getElementById('thankYouModal');
        if (thankYouModal && thankYouModal.style.display === 'block') {
            closeThankYouModal();
        }
    }
});

const dobInput = document.getElementById('modal-dob');
if (dobInput) {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    dobInput.max = `${ yyyy }-${ mm }-${ dd }`;
}

//JS for calling postcode search
window.addEventListener('load', function () {
    const input = document.getElementById('preSearchFormobile_venous');
    if (input) {
        input.addEventListener('keypress', function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                const id = e.target?.id;
                if (id) {
                    preFindServiceProvidersPostcode(id);
                    e.preventDefault();
                }
            }
        });
    }
});


function preFindServiceProvidersPostcode(target_id, requirement) {
    const postcode_box = document.getElementById(target_id);
    if (!postcode_box || postcode_box.value === '') {
        alert('Please enter a valid postcode');
        return;
    }

    const data = {
        'postcode': postcode_box.value,
    };
    const resultBlock = document.getElementById('postcode_locations_search_mob_result');
    if (resultBlock) {
        resultBlock.innerHTML = '<div class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span></div>';
    }

    jQuery.ajax({
        url: "https://api.gbc.health/api/v2/shopify-get-mobile-clinics",
        type: 'GET',
        data: data,
        success: function (response) {
            const result_block = document.getElementById('postcode_locations_search_mob_result');
            if (result_block) {
                result_block.innerHTML = `<div class="d-flex pt-3"><div class="dashicons dashicons-success text-success mx-1"></div><div>` + response.message + `</div></div>`;
            }
        },
        error: function (xhr) {
            const result_block = document.getElementById('postcode_locations_search_mob_result');
            if (!result_block) return;

            let message = "An error occurred";

            if (xhr.responseJSON && xhr.responseJSON.message) {
                message = xhr.responseJSON.message;
            } else if (xhr.responseText) {
                try {
                    const parsed = JSON.parse(xhr.responseText);
                    if (parsed.message) {
                        message = parsed.message;
                    }
                } catch (e) {
                    // Ignore parsing errors, use default message
                }
            }

            result_block.innerHTML = `<div class="d-flex pt-3">
            <div class="dashicons dashicons-no text-danger mx-1"></div>
            <div>${ message }</div>
          </div>`;
        },
    });
}

// JS for women blood product
$(document).on('change', 'input[type="radio"][name*="subscription_picker"]', function () {
    $("input[name='selling_plan']").prop("checked", false);
});

$(document).on('change', 'input[type="radio"][name*="selling_plan"]', function () {
    $("input[name='selling_plan']").not(this).prop("checked", false);
    $("input[name='subscription_picker']").prop("checked", false);
    $(this).parents('label.full_width_variant').find('input[name="subscription_picker"]').prop('checked', true);
});

$('a.var_link').on('click', function () {
    const div_id = $(this).attr('data-attr');
    if (div_id) {
        $('div[data-rel="' + div_id + '"]').removeClass('hidden');
    }
}); 
